import React, { useEffect, useRef, useState } from "react";
import _ from "lodash";
import DataTable from "../../../../Components/UiComponents/DataTable";
import CheckboxElement from "../../../../Components/UiComponents/CheckboxElement";
import ButtonElement from "../../../../Components/UiComponents/ButtonElement";
import HeaderSearchBar from "../../../../Components/UiComponents/HeaderSearchBar";
import { getControlField } from "../../../../Services/tooltipService";
import { getAllRoles,updateRoles } from "../../../../Services/roleService";
import ToastElement from "../../../../Components/UiComponents/ToastElement";
import Loader from "../../../../Components/UiComponents/Loader";
import { useNavigate } from "react-router-dom";
import PlaylistVideos from "../../../../Components/Videos/PlaylistVideos";
import { Dialog } from "primereact/dialog";

const GatewayPermissions = () => {
    const [customerId, setCustomerId] = useState(null);
    const navigate = useNavigate()
    const [branch, setBranch] = useState([]);
    const [privileges, setPrivileges] = useState([]);
    const customerData = localStorage.getItem("enduser");
    if(customerData === null){
        navigate("/login")
        localStorage.clear()
    }
    const customerDataInJSON = JSON.parse(customerData);
    const [searchQuery, setSearchQuery] = useState("");
    const [searchedLength, setSearchedLength] = useState(0);
    const [filterPrivileges, setFilterPrivileges] = useState([]);
    const [projectModule, setProjectModule] = useState([]);
    const [cntlPannel_Permissions, setCntlPannel_Permissions] = useState([]);
    const [allroles, setAllroles] = useState([]);
    const [allchecked,setAllchecked] = useState(null);
    const [isdisabled,setIsdisabled] = useState();
    const [rowStates, setRowStates] = useState({});
    const [loading, setLoading] = useState(false);
    const toastRef = useRef();
    const [unfilteroles,setUnfilteroles] = useState([])
    const [tablesData,setTablesData] = useState()
    const [showVideo, setShowVideo] = useState(false);

    var branchData = customerDataInJSON.branch;

    useEffect(() => {
        if (customerData) {
            setCustomerId(customerDataInJSON.customer);
            setBranch(customerDataInJSON.branch);
        }
    }, []);

    useEffect(() => {
        if (customerId) {
            controlFields();
            getRoles();
        }
    }, [customerId]);

    useEffect(()=>{
       if(allchecked){
        setIsdisabled(true)
       }
       else{
        setIsdisabled(false)
       }
    },[allchecked])

    const controlFields = async () => {
        try {
            if (customerId === null) {
                return;
            }
            // setLoading(true)
            const clientModuleDataResponse = await getControlField(customerId);
            // setLoading(false)
            const clientModuleData = clientModuleDataResponse?.data;

            if (clientModuleData) {
                const projectModules = clientModuleData.cust[0].modules.find(
                    (module) => module.module_name === "Control Panel"
                ).tabs;
                setProjectModule(projectModules);
                const cntlPannel_Permissions = projectModules.find(
                    (tab) => tab.tab_name === "Gateway Permissions"
                );
                setTablesData(cntlPannel_Permissions);
                setCntlPannel_Permissions(cntlPannel_Permissions.display_name);
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    };

    const getRoles = async () => {
        try {
            if (customerId === null) {
                return;
            }
            setLoading(true)
            if (customerId !== null) {
                const isAdminEnd = false;
                const roles = await getAllRoles(customerId, isAdminEnd);
                setAllroles(roles?.data?.roles);
                setUnfilteroles(roles?.data?.roles);
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        } finally {
            setLoading(false)
        }
    };

    const updatePrivilegePermission = async () => {
        try {
            if (customerId === null) {
                return;
            }
            setLoading(true)
            if (customerId !== null) {
                const response = await updateRoles(customerId, privileges);
                if (response && response?.status === 200 && response?.data?.message === "Gateway Permissions Updated Successfully") {
                    toastRef.current.showToast({
                        type: "success",
                        message: `${cntlPannel_Permissions
                            } Saved Successfully`,
                    });
                    setRowStates({});
                }
                else {
                    toastRef.current.showToast({
                        type: "error",
                        message: `${cntlPannel_Permissions
                            } Not saved `,
                    });
                }
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        } finally {
            setLoading(false)
        }
    };

    const roleNameCheck = (rowData) => {
        if (rowData.role_name != null && rowData.role_name !== "") {
            return (
                <div className="form-label text-left">
                    <div key={rowData._id}>{rowData.role_name}</div>
                </div>
            );
        }
    };

    const allcheck = (row, index) => {
        return (
            <CheckboxElement
                id="isAll"
                name="isAll"
                checked={rowStates[index.rowIndex] || false}
                onChangeCheck={(e) => handleIsAllChange(e,index.rowIndex,row)}
                className="mr-2"  
            />
        );
    };

    const handleIsAllChange = (e, rowIndex, row) => {
        const isChecked = e.target.checked;
    
        // Update all permissions to true or false based on "Is All" checkbox
        PermissionChange(e, row._id, null, isChecked);
    
        // Optionally, update the state to reflect that all permissions are enabled/disabled
        setRowStates(prevState => ({
            ...prevState,
            [rowIndex]: isChecked
        }));
    };
    
    

    const assesscheck = (row, index) => {    
        return (
            <CheckboxElement
                id="assess"
                name="assess"
                checked={row?.gateway_permissions?.Target}
                onChangeCheck={(e) =>PermissionChange(e, row._id, "Target")}
                className="mr-2"
                disabled={rowStates[index.rowIndex] || false}
            />
        );
    };

    const PermissionChange = (e, roleId, field1, isAll = false) => {
        const roles = [...unfilteroles];
    
        const roleIndex = roles.findIndex(role => role._id === roleId);
        if (roleIndex === -1) return; 
    
        if (!roles[roleIndex].gateway_permissions) {
            roles[roleIndex].gateway_permissions = {
                'Target': false,
                'Pursuit': false,
                'Pre-Qualify': false,
                'Submission': false,
                'Appointment': false,
                'Deliver': false,
                'Feedback': false
            };
        }
    
        if (isAll) {
            roles[roleIndex].gateway_permissions = {
                'Target': true,
                'Pursuit': true,
                'Pre-Qualify': true,
                'Submission': true,
                'Appointment': true,
                'Deliver': true,
                'Feedback': true
            };
        } else {
            const updatedPermission = e.target.checked;
    
            roles[roleIndex].gateway_permissions[field1] = updatedPermission;
        }
    
        setPrivileges(roles);
    };
    

    const objectivescheck = (row, index) => {
        return (
            <CheckboxElement
                id="Pursuit"
                name="Pursuit"
                checked={row?.gateway_permissions?.Pursuit}
                onChangeCheck={(e) => PermissionChange(e, row._id, "Pursuit")}
                className="mr-2"
                disabled={rowStates[index.rowIndex] || false}
            />
        );
    };

    const riskscheck = (row, index) => {
     return (
            <CheckboxElement
                id="Pre-Qualify"
                name="Pre-Qualify"
                checked={
                    row?.gateway_permissions
                        ? row?.gateway_permissions["Pre-Qualify"]
                        : null
                }
                onChangeCheck={(e) =>
                    PermissionChange(e, row._id, "Pre-Qualify")
                }
                className="mr-2"
                disabled={rowStates[index.rowIndex] || false}
            />
        );
    };

    const targetscheck = (row, index) => {
        return (
            <CheckboxElement
                id="Submission"
                name="Submission"
                checked={row?.gateway_permissions?.Submission}
                onChangeCheck={(e) => PermissionChange(e, row._id, "Submission")}
                className="mr-2"
                disabled={rowStates[index.rowIndex] || false}
            />
        );
    };

    const projectstartcheck = (row, index) => {
        return (
            <CheckboxElement
                id="Appointment"
                name="Appointment"
                checked={row?.gateway_permissions?.Appointment}
                onChangeCheck={(e) =>
                    PermissionChange(e, row._id, "Appointment")
                }
                className="mr-2"
                disabled={rowStates[index.rowIndex] || false}
            />
        );
    };

    const monitorcheck = (row, index) => {
        return (
            <CheckboxElement
                id="Deliver"
                name="Deliver"
                checked={row?.gateway_permissions?.Deliver}
                onChangeCheck={(e) => PermissionChange(e, row._id, "Deliver")}
                className="mr-2"
                disabled={rowStates[index.rowIndex] || false}
            />
        );
    };

    const reportcheck = (row, index) => {
        return (
            <CheckboxElement
                id="feedback"
                name="feedback"
                checked={row?.gateway_permissions?.Feedback}
                onChangeCheck={(e) => PermissionChange(e, row._id, "Feedback")}
                className="mr-2"
                disabled={rowStates[index.rowIndex] || false}
            />
        );
    };

    const columns = [
        {
            field: "role_name",
            header: _.find(tablesData?.tables[0].headers, { header_name: "Role" })?.display_name,
            body: roleNameCheck,
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
        },
        {
            field: "All",
            header: _.find(tablesData?.tables[0].headers, { header_name: "All" })?.display_name,
            body: allcheck,
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
        },
        {
            field: "Assess",
            header: _.find(tablesData?.tables[0].headers, { header_name: "Assess & Strategise" })?.display_name,
            body: assesscheck,
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
        },
        {
            field: "Objectives ",
            header:_.find(tablesData?.tables[0].headers, { header_name: "Objectives & Budget" })?.display_name,
            body: objectivescheck,
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
        },
        {
            field: "Risks",
            header: _.find(tablesData?.tables[0].headers, { header_name: "Risks & Opportunities" })?.display_name,
            body: riskscheck,
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
        },
        {
            field: "Targets",
            header:_.find(tablesData?.tables[0].headers, { header_name: "Targets & Activities" })?.display_name,
            body: targetscheck,
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
        },
        {
            field: "projectstart",
            header: _.find(tablesData?.tables[0].headers, { header_name: "Project Start" })?.display_name,
            body: projectstartcheck,
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
        },
        {
            field: "monitor",
            header: _.find(tablesData?.tables[0].headers, { header_name: "Monitor & Evaluate" })?.display_name,
            body: monitorcheck,
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
        },
        {
            field: "Report",
            header: _.find(tablesData?.tables[0].headers, { header_name: "Report & Feedback" })?.display_name,
            body: reportcheck,
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
        },
    ];

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        filteredQuestionsArray(e.target.value);
    };

    const handleClearFilter = () => {
        setSearchQuery("");
        filteredQuestionsArray("");
    
    };

    const filteredQuestionsArray = (query) => {
        // Convert the query to lowercase for case-insensitive comparison
        const lowerCaseQuery = query.toLowerCase();

        if (lowerCaseQuery.length === 0) {
            // If the query is empty, retrieve the full customer field data
            setSearchedLength(lowerCaseQuery.length); // Update the searched length after resetting the data
            getRoles();


        } else {

            if (lowerCaseQuery.length > searchedLength) {
                setSearchedLength(lowerCaseQuery.length);
            } else {
                setSearchedLength(lowerCaseQuery.length);
            }
            // Filter the customer reference data if the query is not empty
            const filteredData = allroles.filter(item => {
                // Check if any value in the item includes the query string
                return Object.values(item).some(value => {
                    // Convert value to string and to lowercase for comparison
                    // return value.toString().toLowerCase().includes(lowerCaseQuery);
                    return value !== null && value !== undefined && value.toString().toLowerCase().includes(lowerCaseQuery);

                });
            });
            // Update the state with the filtered data
            setAllroles(filteredData);

        }
    }

    const handleButtonClick = () => {
        setShowVideo(true);
    };

    const closeVideo = () => {
        setShowVideo(false);
    };

    return (
        <div className="new-field">
             <ToastElement ref={toastRef} />
             <Loader loading={loading} />
            <div>
                {
                    <div className="form-group row align-items-center mb-0 mt-0">
                        <div className="col pr-0">
                            <div className="form-group row align-items-center mb-0">
                                <div className="col-md-4 pl-0">
                                    <p className="label-text">{cntlPannel_Permissions}</p>
                                    <p className="group-table-text-section">
                                        Please tick and untick the permissions associated with each
                                        role
                                    </p>
                                </div>
                                <div className="col pr-0 d-flex justify-end">
                                    <div className="group-table-search ">
                                        <HeaderSearchBar
                                            value={searchQuery}
                                            onChange={(e) => handleSearchChange(e)}
                                            onClick={handleClearFilter}
                                        />
                                        <ButtonElement
                                            className="upload-button ml-2"
                                            type="button"
                                            icon="pi pi-video"
                                            onClick={handleButtonClick}
                                        />
                                    </div>
                                </div>
                            </div>
                            <DataTable
                                value={allroles}
                                columns={columns}
                                dataKey="_id"
                                gatewaypermissions={true}
                            />
                        </div>
                    </div>
                }
                {
                    <div className="col pr-0 d-flex justify-end">
                        <ButtonElement
                            className="save-button"
                            type="submit"
                            onClick={updatePrivilegePermission}
                            label="Update"
                        />
                    </div>
                }
            </div>
            <Dialog id="videoModal" visible={showVideo}
                breakpoints={{
                    '1200px': '80vw',    // Larger modal on bigger screens
                    '1024px': '85vw',    // Slightly smaller for medium screens
                    '769': '90vw',     // Responsive on tablets
                    '641px': '95vw',     // Almost full-width on mobile
                }}
                modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
            >
                <div className="video-overlay">
                    <div className="video-container">
                        <PlaylistVideos playlistId={process.env.REACT_APP_CONTROL_PANEL_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="control_panel_gateway" />
                    </div>
                </div>
            </Dialog>
        </div>
    );
};

export default GatewayPermissions;
